import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import CareersSection from "../../WhoweAre/ContectUs/CareersSection";

const DedicatedDev = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <CareersSection />
      <Footer />
    </>
  );
};

export default DedicatedDev;
